import * as _actions from './actions';
import _reducer from './reducer';
import _Centre from './model';
import * as _accessors from './accessors';

export const actions = _actions;
export const reducer = _reducer;
export const Centre = _Centre;
export const accessors = _accessors;



// WEBPACK FOOTER //
// ./data/Centre/index.js